import { createReducer, on } from '@ngrx/store';

import { SetOrderGuestSuccess, SetOrderNumber, SetOrderStatus, SetOrderSuccess, SetStepOrderStatus } from './order-status.actions';
import { OrderStatusInitialState, OrderStatusState } from './order-status.state';

export const orderStatusReducer = createReducer(
    OrderStatusInitialState,

    on(SetStepOrderStatus, (state: OrderStatusState, { step }) => {
        return { ...state, step };
    }),

    on(SetOrderStatus, (state: OrderStatusState, { orderStatus }) => {
        return { ...state, orderStatus };
    }),

    on(SetOrderSuccess, (state: OrderStatusState, { orderStatus }) => {
        return { ...state, orderStatus };
    }),

    on(SetOrderGuestSuccess, (state: OrderStatusState, { orderStatus }) => {
        return { ...state, orderStatus };
    }),

    on(SetOrderNumber, (state: OrderStatusState, { orderNumber }) => {
        return { ...state, orderNumber };
    }),
);
